import { action } from 'satcheljs/lib/legacy';
import { ComposeViewState } from 'owa-mail-compose-store';
import RightsManagementFailureCode from 'owa-mail-store/lib/store/schema/RightsManagementFailureCode';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import RightsManagementLicenseDataType from 'owa-service/lib/contract/RightsManagementLicenseDataType';

export default action('setIRMData')(function setIRMData(
    viewState: ComposeViewState,
    IRMData: RightsManagementLicenseDataType
) {
    if (canSetIRMData(viewState)) {
        if (IRMData) {
            viewState.IRMData = IRMData;
        } else if (viewState.IRMData) {
            // If there was IRM data, just set template id to null so that when save draft/send, we know we need to clear the compliance id
            viewState.IRMData.RmsTemplateId = null;
        }
    }
});

function canSetIRMData(viewState: ComposeViewState): boolean {
    const config: OwaUserConfiguration = getUserConfiguration();
    if (config.SegmentationSettings && !config.SegmentationSettings.Irm) {
        return false;
    }

    const IRMData = viewState.IRMData;
    return (
        IRMData == null ||
        (IRMData.RightsManagedMessageDecryptionStatus &&
            IRMData.RightsManagedMessageDecryptionStatus != RightsManagementFailureCode.Success) ||
        IRMData.IsOwner ||
        IRMData.ExportAllowed
    );
}
